import React, { useMemo } from "react";
import { Table } from "antd";
import NoDataPage from "../../NoDataPages/NoDataPage";
import investigationImage from "../../../assets/images/nurseIcons/investigation.svg";
import { getTablePagination } from "../../../utils/tablePagination";
import {
  buildFinalDischargeColumns,
  calculateTotals,
  getColumnMeta,
  getTotalTableScrollWidth,
} from "./finalDischargeColumns";
import "./FinalDischargeDashboard.css";

const formatTotalValue = (value) =>
  value == null || value === 0 ? "-" : value;

const FinalDischargeReportTable = ({
  data = [],
  columnConfig = {},
  loading = false,
  pagination,
  onTableChange,
}) => {
  const columns = useMemo(
    () => buildFinalDischargeColumns(columnConfig),
    [columnConfig]
  );

  const { numericFields, textColsAfterSlNo } = useMemo(
    () => getColumnMeta(columnConfig),
    [columnConfig]
  );

  const totals = useMemo(
    () => calculateTotals(data, numericFields),
    [data, numericFields]
  );

  const scrollX = useMemo(
    () => getTotalTableScrollWidth(columnConfig),
    [columnConfig]
  );

  return (
    <div className="final-discharge-table">
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        bordered
        loading={loading}
        pagination={
          pagination
            ? getTablePagination({
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: true,
                pageSizeOptions: ["50", "100", "200"],
              })
            : false
        }
        onChange={onTableChange}
        scroll={{ x: scrollX, y: 520 }}
        locale={{
          emptyText: (
            <NoDataPage
              title="No discharge records found"
              subtitle="Adjust filters or try a different date range."
              image={investigationImage}
            />
          ),
        }}
        summary={() =>
          numericFields.length > 0 ? (
            <Table.Summary>
              <Table.Summary.Row className="final-discharge-total-row">
                <Table.Summary.Cell index={0} align="center">
                  Total
                </Table.Summary.Cell>
                {textColsAfterSlNo > 0 && (
                  <Table.Summary.Cell
                    index={1}
                    colSpan={textColsAfterSlNo}
                  />
                )}
                {numericFields.map((field) => (
                  <Table.Summary.Cell key={field} align="right">
                    {formatTotalValue(totals[field])}
                  </Table.Summary.Cell>
                ))}
              </Table.Summary.Row>
            </Table.Summary>
          ) : null
        }
      />
    </div>
  );
};

export default FinalDischargeReportTable;
